import React, { lazy } from 'react';
import { dashboardPagesMenu, demoPagesMenu, pageLayoutTypesPagesMenu, pagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';

// PAYMENT
import FoundIn from 'src/pages/presentation/Payment/Foundin';
import FoundOut from 'src/pages/presentation/Payment/FoundOut';
import PaymentManageMent from 'src/pages/presentation/Payment/PaymentManageMent';
import SettleMents from 'src/pages/presentation/Payment/Settlements';
import OrderId from 'src/pages/presentation/orderId';
import UplineSummary from 'src/pages/presentation/Payment/UplineSummary';
import Dowline from 'src/pages/presentation/Payment/Dowline';
import DowlineSelf from 'src/pages/presentation/Payment/DowlineSelf';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};
const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
	HandleLogout: lazy(() => import('../pages/presentation/auth/Logout')),
};
const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const presentation = [
	/**
	 * Landing
	 */
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.logout.path,
		element: <AUTH.HandleLogout />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
	},

	{
		path: demoPagesMenu.orderId.path,
		element: <OrderId />,
	},

	/** ************************************************** */

	// PAGE PAYMENT
	{
		path: dashboardPagesMenu.foundin.path,
		element: <FoundIn />,
	},
	{
		path: dashboardPagesMenu.foundout.path,
		element: <FoundOut />,
	},
	// {
	// 	path: dashboardPagesMenu.paymentmanagement.path,
	// 	element: <PaymentManageMent />,
	// },
	{
		path: dashboardPagesMenu.settlements.path,
		element: <SettleMents />,
	},
	{
		path: dashboardPagesMenu.uplinesummary.path,
		element: <UplineSummary />,
	},
	{
		path: dashboardPagesMenu.downline.path,
		element: <Dowline />,
	},
	{
		path: dashboardPagesMenu.downlineself.path,
		element: <DowlineSelf />,
	},

	/**
	 * Page Layout Types
	 */
	{
		path: pageLayoutTypesPagesMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
	},
];
const contents = [...presentation];

export default contents;
